<template>
  <div class="l-side l-side--info">
    <div class="l-side__inner" :style="{ top: notificationsHeight + 'px' }">
      <p class="l-side-logo">
        <router-link :to="{ name: 'projects' }" class="l-side-logo__link">
          <img
            src="@/assets/img/logo-wh.svg"
            :alt="$constants.siteName"
            class="l-side-logo__image"
          />
        </router-link>
      </p>
      <div class="contents--block report">
        <h2 class="hTitle"><span>SEO動向レポート</span></h2>
        <Loading v-if="pinto.isLoading" variant="inline" transparent />
        <ul v-else-if="pinto.items.length">
          <ListItemPinto
            v-for="item in pinto.items"
            :key="item.id"
            :item="item"
          />
        </ul>
        <ul v-else>
          <li>
            <a
              href="https://service.plan-b.co.jp/blog/seo/17860/"
              target="_blank"
            >
              <div class="thumb">
                <img
                  src="https://service.plan-b.co.jp/wp/wp-content/uploads/blog/office-625893_1280-1000x664.jpg"
                  alt=""
                  width="90"
                />
              </div>
              <div class="detail">
                <p class="title">
                  {{
                    'SEOコンサルの選び方・不安を覚えたら確認するべきこと'
                      | truncateText(46)
                  }}
                </p>
                <p class="date">2019.06.25</p>
              </div>
            </a>
          </li>
          <li>
            <a
              href="https://service.plan-b.co.jp/blog/seo/17216/"
              target="_blank"
            >
              <div class="thumb">
                <img
                  src="https://service.plan-b.co.jp/wp/wp-content/uploads/blog/android-994910.jpg"
                  alt=""
                  width="90"
                />
              </div>
              <div class="detail">
                <p class="title">
                  {{
                    'Fetch as googleがなくなった？Fetch as googleの使い方と新しいサーチコンソールの機能をご紹介'
                      | truncateText(46)
                  }}
                </p>
                <p class="date">2019.06.07</p>
              </div>
            </a>
          </li>
          <li>
            <a
              href="https://service.plan-b.co.jp/blog/seo/16373/"
              target="_blank"
            >
              <div class="thumb">
                <img
                  src="https://service.plan-b.co.jp/wp/wp-content/uploads/blog/understanding_abaout_user_intent.jpg"
                  alt=""
                  width="90"
                />
              </div>
              <div class="detail">
                <p class="title">
                  {{
                    'GoogleのUI / UXからユーザーの検索ニーズを推測しながらSEO対策を考えてみる（前篇）'
                      | truncateText(46)
                  }}
                </p>
                <p class="date">2019.06.21</p>
              </div>
            </a>
          </li>
        </ul>
      </div>
      <!-- <div class="contents--block info">
        <h2 class="hTitle">
          <span>お知らせ</span>
          <Button
            :href="$constants.serviceSiteUrl + '/news/'"
            target="_blank"
            variant="border_dark"
            radius
          >
            See All
          </Button>
        </h2>
        <Loading v-if="news.isLoading" variant="inline" transparent />
        <div v-else class="scroll">
          <perfect-scrollbar>
            <ul>
              <ListItemNews
                v-for="item in news.items"
                :key="item.id"
                :item="item"
              />
              <template v-if="news.items.length < 10">
                <li>
                  <p class="title">
                    GA・GSCデータサマリーのオーガニックの流入推移で、GAデータとGSCデータを見比べられるようになりました。またGSCデータは前年対比のデータを見ることができます。
                  </p>
                  <p class="date">2020.04.27</p>
                </li>
                <li>
                  <p class="title">
                    サイト設定で、サイトと連携しているGAとGSCの情報を確認できるようになりました。<br />自社キーワード分析の貢献キーワードでの分析におけるバブルチャートの評価軸を、クリック率・平均順位・CVから、表示回数・平均順位・CVに変更しました。また、範囲選択スライダーの現在位置がわかりやすくなりました。
                  </p>
                  <p class="date">2020.04.23</p>
                </li>
                <li>
                  <p class="title">
                    「自社キーワード分析」の表示件数が、流入数上位200件から上位1000件に増えました。また、バブルチャートの描画速度改善を行いました。
                  </p>
                  <p class="date">2020.04.22</p>
                </li>
                <li>
                  <p class="title">
                    「自社キーワード分析」のバブルチャートでURLに紐付いた獲得キーワードがハイライト表示されるようになりました。<br />また、「コンテンツ立案」の上位ページのコンテンツに含まれる単語の傾向の精度が向上しました。
                  </p>
                  <p class="date">2020.04.02</p>
                </li>
                <li>
                  <p class="title">
                    主要キーワード分析、コンテンツ調査に『インテント機能』を追加致しました。検索結果1-10位のページタイトルから、ユーザーの検索意図を自動で分類してくれる機能です。<br />また、主要キーワード分析に『関連キーワード』が表示されるようになりました。
                  </p>
                  <p class="date">2020.03.12</p>
                </li>
                <li>
                  <p class="title">
                    自社キーワード分析で『自動抽出した改善提案リスト』が利用出来るようになりました。「クリック率の改善」という課題に対して、最適なキーワードとURLの組み合わせを自動で提案いたします。改善提案の種類は今後増やしていき、順次リリースしていく予定です。
                  </p>
                  <p class="date">2020.02.27</p>
                </li>
                <li>
                  <p class="title">
                    コンテンツ立案機能のサジェストマップに、ご要望が多かった「キーワード別検索ボリューム」を追加致しました。<br />また、クロスドメイントラッキング設定を行っているGAアカウントをご登録頂きました場合も、自社キーワード分析において、コンバージョン値が正しく計測されるよう対応致しました。<br />流入ページとカートページのドメインが違うケースでも、コンバージョンに至った流入キーワードの分析が可能となりますので、ぜひご活用ください。
                  </p>
                  <p class="date">2020.02.14</p>
                </li>
                <li>
                  <p class="title">
                    コンテンツ作成をサポートする『コンテンツ立案機能』をリリースしました。<br />また、自社キーワード分析に『貢献キーワードでの分析機能』が増え、コンバージョンに貢献しているキーワードを分析できるようになりました。GA・GSCデータサマリーでコンバージョン合計値の推移も確認できます。
                  </p>
                  <p class="date">2020.01.22</p>
                </li>
                <li>
                  <p class="title">
                    自社キーワード分析に、ご要望が多かった『URLでの絞り込み機能』を追加致しました。<br />特定のページやディレクトリを分析したい時などに、ぜひご活用ください。
                  </p>
                  <p class="date">2019.12.03</p>
                </li>
                <li>
                  <p class="title">
                    サービスのご提供を開始致しました。<br />
                    皆さまのWebマーケティング活動をサポートするべく、
                    細かいアップデートを重ね、より新しい機能開発も進めてまいります。<br />
                    今後とも、SEARCH WRITEを宜しくお願い致します。
                  </p>
                  <p class="date">2019.10.31</p>
                </li>
              </template>
            </ul>
          </perfect-scrollbar>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
// import Button from '@/components/Button';
// import ListItemNews from '@/components/layouts/side/ListItemNews';
import ListItemPinto from '@/components/layouts/side/ListItemPinto';
import Loading from '@/components/Loading';
import apiBlog from '@/api/blog';
// import { PerfectScrollbar } from 'vue2-perfect-scrollbar';

export default {
  components: {
    // Button,
    // ListItemNews,
    ListItemPinto,
    Loading
    // PerfectScrollbar
  },
  data() {
    return {
      news: {
        items: [],
        isLoading: true
      },
      pinto: {
        items: [],
        isLoading: true
      }
    };
  },
  computed: {
    notificationsHeight() {
      return this.$store.state.view.size.notificationsHeight;
    }
  },
  created() {
    // this.getNewsPosts();
    this.getPintoPosts();
  },
  methods: {
    // getNewsPosts() {
    //   let params = {
    //     per_page: 10
    //   };
    //   apiBlog.news
    //     .get(params)
    //     .then(response => {
    //       this.news.items = response.data;
    //       this.news.isLoading = false;
    //     })
    //     .catch(error => {
    //       this.news.isLoading = false;
    //     });
    // },
    getPintoPosts() {
      let params = {
        per_page: 3
      };
      apiBlog.pinto
        .get(params)
        .then(response => {
          this.pinto.items = response.data;
          this.pinto.isLoading = false;
        })
        .catch(error => {
          this.pinto.isLoading = false;
        });
    }
  }
};
</script>
